import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import { verticalEmbedModals } from "./constants";
import { InsertModal } from "./modals/InsertModal";
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(InsertModal, {
          modalId: verticalEmbedModals.replace
        }),
        id: verticalEmbedModals.replace,
        noPadding: true
      },
      attributes: {
        active: {
          id: "IS_VERTICAL_EMBED_REPLACE_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(verticalEmbedModals.replace))
        }
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        if (modals?.isModalOpen(verticalEmbedModals.replace)) {
          modals.closeModal(verticalEmbedModals.replace);
        } else {
          modals?.openModal({
            id: verticalEmbedModals.replace,
            Component: InsertModal,
            componentProps: {
              modalId: verticalEmbedModals.replace,
              verticalsApi: config?.verticalsApi,
              componentData: { type: selectedNode.attrs.type },
              nodeId: selectedNode.attrs.id
            },
            withTransition: true,
            noPadding: true,
            type: "exclusive",
            layout: isMobile ? "fullscreen" : "floating",
            positioning: {
              referenceElement: referenceElement?.closest("[data-hook~=floating-plugin-toolbar]") ?? referenceElement,
              placement: "right-start"
            },
            enableDrag: !isMobile,
            dragHandleSelector: "[data-drag-handler]"
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
